import { MapContainer, TileLayer, CircleMarker, Popup } from "react-leaflet";
import MarkerClusterGroup from "react-leaflet-cluster";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import { Link } from "react-router-dom";

const COLOR = { Verified: "#059669", Unverified: "#d97706", Stale: "#e11d48" };

function Markers({ sites, onSelect }) {
  return sites.map((s) => (
    <CircleMarker key={s.id} center={[s.latitude, s.longitude]} radius={7}
      pathOptions={{ color: COLOR[s.confidence?.label] || "#64748b", fillColor: COLOR[s.confidence?.label] || "#64748b", fillOpacity: 0.7, weight: 2 }}
      eventHandlers={onSelect ? { click: () => onSelect(s.id) } : undefined}>
      {!onSelect && (
        <Popup>
          <div className="text-sm">
            <div className="font-semibold text-slate-900">{s.name}</div>
            <div className="mt-1 text-xs">
              <span style={{ color: COLOR[s.confidence?.label] }}>{s.confidence?.label}</span>
            </div>
            <Link to={`/sites/${s.id}`} className="mt-1 inline-block text-emerald-600 text-xs font-medium">View detail →</Link>
          </div>
        </Popup>
      )}
    </CircleMarker>
  ));
}

export default function CoverageMap({ sites = [], center = { lat: 17.385, lng: 78.4867 }, zoom = 11, height = 420, cluster = false, onSelect = null }) {
  return (
    <MapContainer center={[center.lat, center.lng]} zoom={zoom} style={{ height, width: "100%" }} scrollWheelZoom={false}>
      <TileLayer attribution='&copy; OpenStreetMap' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      {cluster ? (
        <MarkerClusterGroup chunkedLoading maxClusterRadius={50}>
          <Markers sites={sites} onSelect={onSelect} />
        </MarkerClusterGroup>
      ) : (
        <Markers sites={sites} onSelect={onSelect} />
      )}
    </MapContainer>
  );
}
